/**
 * BookmarkIcon — A bookmark. Hugeicons bookmark-02 (MIT).
 */

import svg from './svg/bookmark.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const BookmarkIcon = makeSvgIcon('bookmark', svg);
